import Link from "next/link"
import { useRouter } from "next/router"
import Script from "next/script"
import { useEffect } from "react"
import { getAllFAQPaths, getFAQItem, getGlobals } from "storyblok/api"
import TitleBanner from "components/DynamicComponent/atoms/TitleBanner"
import Meta from "components/Meta"
import richText from "utilities/richText"
import getPlainText from "utilities/getPlainText"

export default function FAQ({ faqItem: { question, answer } }) {
  const router = useRouter()

  useEffect(() => {
    document.getElementById("faq-content").scrollIntoView({ behavior: "instant", block: "start" })
  }, [])

  return (
    <>
      <Meta
        info={{
          title: question,
          description: getPlainText(answer, { addNewlines: false }),
        }}
      />
      <TitleBanner
        blok={{
          heading: "Frequently Asked Questions",
          pattern: "dog",
        }}
      />
      <section className="py-12 px-8" id="faq-content">
        <div className="max-w-screen-xl mx-auto flex flex-col-reverse md:flex-row">
          <Link
            href={`/frequently-asked-questions#${router.asPath.split("/").filter((string) => string !== "")[1]}`}
            className="min-w-max text-green-pine underline hover:no-underline font-bold pt-6 md:pt-1 md:pr-8 lg:pr-20 self-start before:content-['‹_']"
          >
            Back to FAQ
          </Link>
          <div>
            <h2 className="pb-6">{question}</h2>
            {richText(answer)}
          </div>
        </div>
      </section>
      <Script type="application/ld+json" id={`${question}-schema`}>
        {`{
          "@context": "https://schema.org",
          "@type": "Question",
          "name": "${question}",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "${getPlainText(answer, { addNewlines: false })}"
          }
        }`}
      </Script>
    </>
  )
}

export async function getStaticProps({ params: { category, slug } }) {
  const globals = await getGlobals()
  const faqItem = await getFAQItem(`frequently-asked-questions/${category}/${slug}`)

  return {
    props: {
      faqItem,
      globals: globals ?? null,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getAllFAQPaths(),
    fallback: false,
  }
}
